"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toDate_1 = __importDefault(require("../toDate"));
function deserializeDeckDocument(deckData, id, userId) {
    return __assign(__assign({}, deckData), { id: id,
        userId: userId, cards: Object.keys(deckData.cards)
            .map(function (cardId) {
            var card = deckData.cards[cardId];
            return __assign(__assign({}, card), { id: cardId, createdAt: toDate_1.default(card.createdAt), nextReview: card.nextReview ? toDate_1.default(card.nextReview) : null, lastReview: card.lastReview ? toDate_1.default(card.lastReview) : null, subcategories: card.subcategories || [] });
        })
            .filter(function (card) { return card.id !== 'undefined'; }), notes: deckData.notes
            ? Object.keys(deckData.notes)
                .map(function (noteId) {
                var note = deckData.notes[noteId];
                return __assign(__assign({}, note), { id: noteId, createdAt: toDate_1.default(note.createdAt), subcategories: note.subcategories || [] });
            })
                .filter(function (note) { return note.id !== 'undefined'; })
            : [] });
}
exports.default = deserializeDeckDocument;
//# sourceMappingURL=deserializeDeckDocument.js.map